var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 448 448",
    enableBackground: "new 0 0 448 448",
    xmlSpace: "preserve",
    width: "64px",
    height: "64px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M288,0v160h160V0H288z M416,128h-96V32h96V128z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 64,
    fill: "#323232",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 64,
    fill: "#323232",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#323232",
    points: "256,64 224,64 224,32 256,32 256,0 192,0 192,96 224,96 224,128 256,128 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M160,160V0H0v160h32H160z M32,32h96v96H32V32z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#323232",
    points: "0,192 0,256 32,256 32,224 64,224 64,192 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#323232",
    points: "224,224 256,224 256,160 224,160 224,128 192,128 192,192 224,192 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 192,
    fill: "#323232",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 192,
    fill: "#323232",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#323232",
    points: "320,256 320,288 352,288 352,320 384,320 384,256 352,256 352,224 320,224 320,192 288,192 288,224 256,224 256,256 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 224,
    fill: "#323232",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M0,288v160h160V288H0z M128,416H32v-96h96V416z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#323232",
    points: "256,256 224,256 224,224 192,224 192,192 96,192 96,224 64,224 64,256 128,256 128,224 160,224 160,256 192,256 192,288 224,288 224,320 256,320 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 288,
    fill: "#323232",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 256,
    fill: "#323232",
    width: 32,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 320,
    fill: "#323232",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 320,
    fill: "#323232",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 352,
    fill: "#323232",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#323232",
    points: "320,384 320,352 288,352 288,320 256,320 256,352 224,352 224,320 192,320 192,384 224,384 224,416 256,416 256,384 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#323232",
    points: "352,384 320,384 320,416 352,416 352,448 384,448 384,352 352,352 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 352,
    fill: "#323232",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 416,
    fill: "#323232",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 416,
    fill: "#323232",
    width: 64,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 416,
    fill: "#323232",
    width: 32,
    height: 32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.e9d72e283f7f09fc500eca8cc9cf17b0.svg";
export { ForwardRef as ReactComponent };